import { FcGenericItemBase } from '../FcGenericItemBase.interface';

export type FcPersonWebAccountItemType = FcPersonWebAccountListItemDto;

export interface FcPersonWebAccountListItemDto extends FcGenericItemBase {
    LimitedTimePassword: boolean;
    Password: string;
    PatientWebAccess: boolean;
    PersonUid: string;
    UserName: string;
    ExpirationDate?: string;
    FacilityPortalWebAccess: boolean;
    PatientSecurityAnswerList?: string;
    Person?: string;
    PersonWebExists?: boolean;
    ProviderWebAccess?: boolean;
    UserPrmWebAccess?: boolean;
}

export interface FcModifyPersonWebAccountListItemDto extends Partial<FcPersonWebAccountListItemDto> {}

export enum WebAccessTypeEnum {
    Patient = 'Patient',
    FacilityPortal = 'FacilityPortal'
}
